import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@jwp/ott-theme/assets/icons/check.svg?react';
import Share from '@jwp/ott-theme/assets/icons/share.svg?react';
import useBreakpoint, { Breakpoint } from '@jwp/ott-ui-react/src/hooks/useBreakpoint';
import { useUIControls } from '@jwp/ott-hooks-react/src/useUIControls';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import ReactGA from 'react-ga4';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { useGADeviceType } from '@jwp/ott-common/src/utils/GADeviceType';

import { copyToClipboard } from '../../utils/clipboard';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { useTheme } from '../../../../../ThemeContext';
import { sendGAEvent } from '@jwp/ott-hooks-react/src/useAnalytics';

type Props = {
  title: string;
  description: string;
  url: string;
  mediaId?: string | unknown;
};

const ShareButton = ({ title, description, url, mediaId }: Props) => {
  const { t } = useTranslation();
  const breakpoint = useBreakpoint();
  const { universalStyles } = useTheme();
  const [hasShared, setHasShared] = useState<boolean>(false);
  const { buttonIconOnly, buttonLabelOnly, buttonLabelWithIcon } = useUIControls();
  const { isGoogleAnalytics, isAnalyticsEnable } = useAppConfig();
  const user = useAccountStore((state) => state.user);
  const isLoggedIn = !!user;
  const userId = isLoggedIn ? user.id : 'Guest user';
  const deviceType = useGADeviceType();

  const onShareClick = async () => {
    if (isAnalyticsEnable) {
      sendGAEvent('share_clicked', {
        video_id: mediaId,
        userid_no: userId,
        device_type: deviceType,
      });
    }

    if (typeof navigator.share === 'function') {
      await navigator.share({ title, text: description, url });
      return;
    }

    copyToClipboard(window.location.href);
    setHasShared(true);
    setTimeout(() => setHasShared(false), 2000);
  };

  return (
    <Button
      label={buttonLabelOnly || buttonLabelWithIcon ? (hasShared ? t('video:copied_url') : t('video:share')) : undefined}
      // color="videoDetailButton"
      variant="contained"
      size="exlarge"
      startIcon={buttonIconOnly || buttonLabelWithIcon ? hasShared ? <Icon icon={Check} /> : <Icon icon={Share} /> : undefined}
      onClick={onShareClick}
      active={hasShared}
      fullWidth={breakpoint < Breakpoint.md}
      // style={universalStyles.favoriteButtonBackground}
      textStyle={universalStyles.favoriteAndShareButtonText}
    />
  );
};

export default ShareButton;
